export const RQ_POST_IMAGES_API = {
  url: 'api/home/register',
  method: 'POST',
  auth: true,
};

export const RQ_PUT_UPDATE_IMAGES_API = {
  url: 'api/home/update/<%= id %>',
  method: 'PUT',
  auth: true,
  search:true,
};

export const RQ_GET_ALL_IMAGES_API = {
  url: 'api/home/all',
  method: 'GET',
  auth:false,
};

export const RQ_DELETE_IMAGES_API = {
  url:'/api/home/<%= id %>',
  method: 'DELETE',
  auth: true,
};
